import { Box, Button, TextField, Typography } from "@mui/material"
import { useTranslation } from "react-i18next";
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';



const ChangePasswordView = () => {
    const { t } = useTranslation('global');

    const schema = yup.object().shape({
        oldPassword: yup.string().required(t("Old password is required") || ''),
        newPassword: yup.string().required(t("New password is required") || ''),
        confirmPassword: yup.string().required(t("Confirm password is required") || '').oneOf([yup.ref('newPassword'), null!],t( 'Passwords must match') || ''),
    });

    const { register, formState: { errors }, handleSubmit } = useForm({
        resolver: yupResolver(schema)
    });
    const onSubmit = (data: any) => console.log(data);

    return <Box>
        <Typography variant="h6" fontWeight="bold">{t('Change password')}</Typography>
        <Box mt={5}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Typography>{t('Old password')}</Typography>
                <TextField {...register("oldPassword")} placeholder={t('Enter old password') ?? ''} fullWidth sx={{ maxWidth: 350 }} margin="normal"
                    error={Boolean(errors?.oldPassword)} helperText={errors?.oldPassword?.message?.toString()} />
                <Typography>{t('New password')}</Typography>
                <TextField type="password" {...register("newPassword")} placeholder={t("Enter new password") ?? ''} fullWidth sx={{ maxWidth: 350 }} margin="normal"
                    error={Boolean(errors?.newPassword)} helperText={errors?.newPassword?.message?.toString()} />
                <Typography>{t('Confirm new password')}</Typography>
                <TextField type="password" {...register("confirmPassword")} placeholder={t("Enter confirm new password") ?? ''} fullWidth sx={{ maxWidth: 350 }} margin="normal"
                    error={Boolean(errors?.confirmPassword)} helperText={errors?.confirmPassword?.message?.toString()} />
                <Box mt={2}>
                    <Button type="submit" variant="contained" sx={{ textTransform: 'none' }}>{t('Change password')}</Button>
                </Box>
            </form>
        </Box>
    </Box>
}
export default ChangePasswordView;